import { headerStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import Filter from "@insite/mobius/Icons/Filter";
import { css } from "styled-components";

headerStyles.container = {
    gap: 8,
    css: css`
        padding-bottom: 10px;
    `,
};
headerStyles.toggleFilterIcon = {
    src: Filter,
    size: 24,
    color: "primary",
};
